import AscendingSortingIcon from '@/images/ArrowUpIcon.svg?react';
import DescendingSortingIcon from '@/images/ArrowDownIcon.svg?react';
import { EmptySortingIcon, TableHeaderCellIcon } from './styles';

type TableSortingType = {
  isAscendingSorting: boolean;
  isDescendingSorting: boolean;
  isUnsorted: boolean;
};

export const TableSorting = ({ isAscendingSorting, isDescendingSorting, isUnsorted }: TableSortingType) => {
  return (
    <TableHeaderCellIcon>
      {isUnsorted && (
        <>
          <AscendingSortingIcon />
          <DescendingSortingIcon />
        </>
      )}
      {isAscendingSorting && (
        <>
          <AscendingSortingIcon />
          <EmptySortingIcon />
        </>
      )}
      {isDescendingSorting && (
        <>
          <EmptySortingIcon />
          <DescendingSortingIcon />
        </>
      )}
    </TableHeaderCellIcon>
  );
};
